export default "__VITE_ASSET__aRnJtdPX__"